import {
    AUTH_INTERNAL_CLIENT_PARAM,
    AuthDevMode,
    AuthOptions,
} from '@99designs/design-services-common';
import { INTERNAL_ACCESS_CLIENT } from './clients';

export interface ClientOverride {
    developmentMode: AuthDevMode;
    options?: AuthOptions;
}

export const authDevMode = (): AuthDevMode => {
    const isAuthDevMode = process.env.NEXT_PUBLIC_AUTH_DEVELOPMENT_MODE === 'true';
    if (!isAuthDevMode) {
        return false;
    }

    const redirectUriOrigin = typeof window !== 'undefined' ? window.location.origin : undefined;
    const clientID = process.env.NEXT_PUBLIC_AUTH0_CLIENT;
    if (!clientID) {
        return { redirectUriOrigin };
    }

    return { clientID, domain: 'oauth.cimpress.io', redirectUriOrigin };
};

export function buildAuthConfiguration(): ClientOverride {
    if (typeof window !== 'undefined') {
        const shouldUseInternalAuthClient = new URLSearchParams(window.location.search).get(
            AUTH_INTERNAL_CLIENT_PARAM
        );

        if (shouldUseInternalAuthClient) {
            return INTERNAL_ACCESS_CLIENT;
        }
    }

    return {
        developmentMode: authDevMode(),
    };
}
